<template>
    <!-- 신규 리포트 발급 준비 중 화면(!isWaitingPublish) -->
    <template v-if="!props.data.IsWaitingPublish">
        <div :style="firstWrapStyle" class="before-first-wrap" :class="{ 'is-subscribed': !isSubscribed }">
            <div class="first-wrap-title h3">
                {{ props.data.WaitingPublishModuleSchema?.WelcomeText ?? '' }}
            </div>
            <ul class="status-content-list">
                <li
                    class="status-content-item body-3--regular"
                    v-for="(item, index) in props.data.WaitingPublishModuleSchema?.WaitingPublishSentenceList"
                    :key="index"
                >
                    <div class="item-status-content-outer">
                        <div class="item-status-content-wrap">
                            <span class="item-index">{{ index + 1 }}. </span>
                            <p class="item-content body-3--regular">
                                {{ item.GateWayText }}
                                <!-- <span class="smallT">6.30까지</span> -->
                            </p>
                        </div>
                        <div class="item-dash-line"></div>
                    </div>

                    <div
                        class="item-status-chip caption--regular"
                        :style="{
                            ...(item.StatusTextColor && { color: item.StatusTextColor }),
                            fontWeight: item.IsStatusTextBold ? 'bold' : 'normal',
                        }"
                    >
                        {{ item.StatusText }}
                    </div>
                </li>
            </ul>
        </div>
    </template>

    <!-- 신규 리포트 발급 준비 중 화면(isWaitingPublish) -->
    <template v-else="props.data.IsWaitingPublish">
        <div :style="firstWrapStyle" class="before-first-waiting-wrap" :class="{ 'is-subscribed': !isSubscribed }">
            <img src="../../../public/assets/images/pro-report-logo.png" alt="Pro 로고" />
            <div class="first-wrap-title h3">
                {{ props.data.WaitingPublishModuleSchema?.WelcomeText ?? '' }}
            </div>
        </div>
    </template>
</template>

<script setup lang="ts">
import type { ReportPublishingTrackingData } from '@common/openapi-client';
import { computed, type CSSProperties } from 'vue';
import { isAppleDevice } from '@common/common/utils/utils';

const props = defineProps<{
    isSubscribed: boolean;
    data: ReportPublishingTrackingData;
    reportContainerBottomPadding: CSSProperties;
    headerHeight: number;
    reportExistingEndDates: string[];
    cardHeight: number;
}>();

const firstWrapStyle = computed(() => {
    // reportExistingEndDates가 비어있으면 빈 객체 반환
    if (props.reportExistingEndDates.length === 0) {
        if (!props.isSubscribed) {
            return {};
        }
    }

    return {
        marginTop: `${props.headerHeight + (isAppleDevice() ? 22 : 0)}px`,
        ...props.reportContainerBottomPadding,
    };
});
</script>

<style scoped lang="scss">
.before-first-wrap {
    width: calc(100% - 3rem);
    display: flex;
    flex-direction: column;
    padding: 4rem 1.5rem 0 1.5rem;
    box-sizing: content-box;

    .first-wrap-title {
        text-align: left;
        padding-bottom: 1.7rem;
    }

    .status-content-list {
        white-space: pre-line;

        .status-content-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 1.2rem;

            .item-status-content-outer {
                width: calc(100% - 3.6rem);
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .item-status-content-wrap {
                flex: 0 1 90%;
                max-width: max-content;
                display: flex;
                align-items: flex-start;
                margin-right: 0.6rem;
                color: $grey-7;

                .item-index {
                    margin-right: 0.4rem;
                }

                .item-content {
                    flex: 1;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: keep-all;
                }
            }

            .item-dash-line {
                flex: 1;
                height: 1px;
                background-image: repeating-linear-gradient(
                    to right,
                    #606976 0,
                    #606976 2px,
                    transparent 2px,
                    transparent 4px
                );
            }
        }
    }

    &.is-subscribed {
        height: 100%;
    }
}

.first-wrap-title {
    white-space: pre-line;
    word-break: keep-all;
}

.before-first-waiting-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 6.9rem 1.5rem 8rem 1.5rem;
    box-sizing: border-box;

    .first-wrap-title {
        text-align: center;
        padding-top: 2.2rem;
    }

    img {
        width: 45%;
    }
}
</style>
